import React, { useState } from "react"
import { Col, Row } from "react-bootstrap"
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin"
import { getRestoLogin } from "../../Helpers/Utils/Common"


function AuditTrails() {
  const [inactive, setInactive] = useState(true)
  let date = new Date().toLocaleDateString("en-CA")
  const restoType = getRestoLogin();

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive)
        }}
        active={"Reports"} //Dashboard navbar index
        page={"Reports"}
      />
      <div
        className={`container bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col xl={6}>
            <h1 className="page-title-menu"> E-JOURNAL REPORT</h1>
          </Col>
          <Col xl={6}>
          </Col>
        </Row>
        
        <hr />
        <div className="row">
          <Col xs="5"></Col>
          <Col xs="3" className="pt-5">
            <button className="export-btn">
              <a
                style={{ textDecoration: "none", color: "#ffffff" }}
                href={`http://localhost/${restoType}-pos-api/public/ej/${date}.txt`}
              >
                Export to Ejournal
              </a>
            </button>
          </Col>
          <Col xs="3"></Col>
        </div>
      </div>
      <div>
        <label className="powered-label text-center">
          Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
        </label>
      </div>
    </div>
  )
}

export default AuditTrails
